import type { ClientCalendarSearchEvent } from '@/api/beatlyApi';
import { getPathForPage } from '@/routes';

/**
 * SPA path for a calendar row: drafts for draft deadlines, publications when collab-scoped,
 * the beat brief under Briefs & Beats for BEAT_START/BEAT_END, otherwise the campaign overview.
 */
export function getHrefForCalendarEvent(
  event: Pick<ClientCalendarSearchEvent, 'type' | 'campaign_id' | 'collaboration_id' | 'beat_id'>,
): string | null {
  const campaignId = (event.campaign_id ?? '').trim();
  if (!campaignId) return null;

  const beatIdRaw = (event.beat_id ?? '').trim();
  const beatId = beatIdRaw || undefined;
  const collab = (event.collaboration_id ?? '').trim();

  if (event.type === 'DRAFT_DEADLINE') {
    return getPathForPage('see-campaigns', { campaignId, subTab: 'contentApproval', beatId });
  }
  if (collab) {
    return getPathForPage('see-campaigns', { campaignId, subTab: 'publications' });
  }
  const useBeat =
    Boolean(beatId) && (event.type === 'BEAT_START' || event.type === 'BEAT_END');
  return getPathForPage('see-campaigns', {
    campaignId,
    subTab: useBeat ? 'briefsBeats' : 'overview',
    beatId: useBeat ? beatId : undefined,
  });
}
